import apiRequest from '../apis/api-request';
import { selectAuthToken } from '../redux/reducers/authReducers';
import { store } from '../redux/store';

const dashboardService = {

    superAdminDashboard: async (data) => {
        const actionPage = data && data.actionPage ? data.actionPage : 0;
        const commentPage = data && data.commentPage ? data.commentPage : 0;
        const size = data && data.size ? data.size : 20;
        return apiRequest({
            method: "GET",
            url: `/api/dashboard/super-admin?actionPage=${actionPage}&commentPage=${commentPage}&size=${size}`,
        });
    }

};

export default dashboardService;